import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-case-patient',
    templateUrl: './skeleton-case-patient.component.html',
    styleUrls: ['./skeleton-case-patient.component.scss'],
    standalone: false
})
export class SkeletonCasePatientComponent {
  @Input() teacher: boolean;

  constructor() {}
}
